import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import configuratorReducer from './configurator-slice';
import { api, api2, api3, drupalApi } from './api-slice'
import devReducer from './dev-slice';
import mainReducer from './main-slice';
import popupReducer from './popup-slice'
import basketReducer from './basket-slice';
import basket3DReducer from './basket-3d-slice';
import viewerReducer from './viewer-slice';

export const store = configureStore({
  reducer: {
    main: mainReducer,
    configurator: configuratorReducer,
    [api.reducerPath]: api.reducer,
    [api2.reducerPath]: api2.reducer,
    [api3.reducerPath]: api3.reducer,
    [drupalApi.reducerPath]: drupalApi.reducer,
    dev: devReducer,
    popup: popupReducer,
    basket: basketReducer,
    basket3D: basket3DReducer,
    viewer: viewerReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat([
    api.middleware,
    api2.middleware,
    api3.middleware,
    drupalApi.middleware,
  ])
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
